import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';
import logger from './logger';

/**
 * Creates a commentLike / replyLike notification via Cloud Function.
 * Fire-and-forget friendly — logs failures, never throws.
 */
export function triggerLikeCommentNotification(payload) {
  return httpsCallable(functions, 'likeCommentNotification')(payload)
    .then((result) => {
      logger.info('[likeCommentNotification] result:', result.data);
      return result.data;
    })
    .catch((error) => {
      logger.warn(
        '[likeCommentNotification] error:',
        error?.message,
        error?.details,
        payload
      );
      return null;
    });
}
